import { FunctionComponent, PropsWithChildren } from 'react';

import { InputPairContainer } from '../InputPairContainer';
import { PolicyInput } from '../PolicyInput';

export const BasicBehaviorField = ({
  LabelComponent,
}: {
  LabelComponent?: FunctionComponent<PropsWithChildren>;
}) => {
  return (
    <InputPairContainer data-testid="basic-behavior-field">
      <PolicyInput
        name="minReplicas"
        label="Min"
        variant="number"
        size="small"
        testId="min-replicas"
        LabelComponent={LabelComponent}
        endAdornment="replicas"
      />

      <PolicyInput
        name="maxReplicas"
        label="Max"
        variant="number"
        size="small"
        testId="max-replicas"
        LabelComponent={LabelComponent}
        endAdornment="replicas"
      />
    </InputPairContainer>
  );
};
